/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDayDto
 */
export interface CreateDayDto {
    /**
     * Day number in the itinerary sequence
     * @type {number}
     * @memberof CreateDayDto
     */
    number: number;
    /**
     * Title of the day
     * @type {string}
     * @memberof CreateDayDto
     */
    title?: string;
    /**
     * Description of the day activities
     * @type {string}
     * @memberof CreateDayDto
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateDayDto interface.
 */
export function instanceOfCreateDayDto(value: object): value is CreateDayDto {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function CreateDayDtoFromJSON(json: any): CreateDayDto {
    return CreateDayDtoFromJSONTyped(json, false);
}

export function CreateDayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

  export function CreateDayDtoToJSON(json: any): CreateDayDto {
      return CreateDayDtoToJSONTyped(json, false);
  }

  export function CreateDayDtoToJSONTyped(value?: CreateDayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'title': value['title'],
        'description': value['description'],
    };
}

